if (!customElements.get('sw-collection-faqs')) {
  customElements.define('sw-collection-faqs', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.enhance());
    }

    enhance() {
      if (this.dataset.faqReady) return;
      const nodes = [...this.childNodes];
      if (!nodes.length) return;
      let faqLevel = 0;
      let question = null;
      let answers = [];
      const level = node => node.nodeType === 1 && /^H[2-6]$/.test(node.tagName) ? Number(node.tagName[1]) : 0;
      const isQuestion = node => {
        if (node.nodeType !== 1 || !node.textContent.trim().endsWith('?')) return false;
        if (level(node)) return level(node) > faqLevel;
        if (node.tagName !== 'P') return false;
        return node.children.length === 1 &&
          ['STRONG', 'B'].includes(node.firstElementChild.tagName) &&
          node.textContent.trim() === node.firstElementChild.textContent.trim();
      };
      const finish = () => {
        if (!question) return;
        if (answers.some(node => node.textContent.trim() || (node.nodeType === 1 && node.querySelector('img,video,iframe')))) {
          const details = document.createElement('details');
          details.className = 'sw-collection-faq';
          const summary = document.createElement('summary');
          summary.className = 'sw-collection-faq__question';
          const answer = document.createElement('div');
          answer.className = 'sw-collection-faq__answer';
          question.before(details);
          summary.append(question);
          answer.append(...answers);
          details.append(summary, answer);
        }
        question = null;
        answers = [];
      };
      for (const node of nodes) {
        const headingLevel = level(node);
        if (headingLevel && /\bfaqs?\b|frequently asked questions/i.test(node.textContent)) {
          finish();
          faqLevel = headingLevel;
        } else if (headingLevel && faqLevel && headingLevel <= faqLevel) {
          finish();
          faqLevel = 0;
        } else if (faqLevel && isQuestion(node)) {
          finish();
          question = node;
        } else if (question) {
          answers.push(node);
        }
      }
      finish();
      this.dataset.faqReady = 'true';
    }
  });
}
